import { create } from 'zustand';

export type ToastType = {
	icon?: 'alert' | 'confirm' | string; // 아이콘 (alert, confirm, 직접 지정 가능)
	content: string; // 보여줄 문구
	subContent?: string;
	showTime?: number; // 몇 밀리초동안 보일지
};

type ToastStore = {
	toast: ToastType | null;
	openToast: (payload: ToastType) => void;
	closeToast: () => void;
	closeAll: () => void;
};

export const useToastStore = create<ToastStore>((set) => ({
	toast: null,
	openToast: (payload) => set({ toast: payload }),
	closeToast: () => set({ toast: null }),
	closeAll: () => set({ toast: null }),
}));
